import { Icon, IconProps } from "../Icon";

const Hamburger = (props: IconProps) => (
  <Icon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M4 20H28V22H4V20ZM4 10H28V12H4V10Z" fill="currentColor" />
  </Icon>
);

export default Hamburger;
